<template>
	<div style="margin-left: 21px;">
		<!-- 导入弹窗 -->
		<el-dialog title="选择文件" :visible.sync="daorudiag" width="800px" :close-on-click-modal="false" append-to-body
			v-dialogDrag>
			<!-- <minhead :headtitle="daorutitle" :isdiag="true"></minhead> -->
			<div class="Verticalcenter" style="margin-top: 82px;">
				<div class="Centerhorizontally" style="margin-left: 260px;">
					<el-input style="width: 300px;margin-right: 16px;" disabled v-model="upfilename"></el-input>

					<label style="display: flex;align-items: center;">
						<div class="Centerhorizontally bt1">选择文件</div>
						<input type="file" class="sendinput" @change="uploadFile($event)" :value="filestate" />
					</label>
				</div>
			</div>
			<div style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="sureupload">确定</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="daorudiag = false">关闭</div>
			</div>
			<!--  <div class="buttomanniu">
                <el-button type="primary" @click="sureupload">确定</el-button>
                <el-button @click="daorudiag = false">关闭</el-button>
            </div> -->
		</el-dialog>

		<!-- 客户主联系人数据 -->
		<!-- 客户主联系人编辑弹层 -->
		<el-dialog :title="xztitle" :visible.sync="lianxirendiag" width="900px" :close-on-click-modal="false">
			<!-- <minhead :Stringtitle="xztitle" :isdiag="true"></minhead> -->
			<el-form :model="ruleLxrForm" :rules="xztitle == '查看客户联系人信息' ? '' : rulelxrs" ref="ruleLxrForm"
				label-width="100px" class="demo-ruleForm">
				<div class="demo-ruleForm-item">
					<el-form-item label="客户编号:" prop="goufbh" :label-width="formLabelWidth">
						<el-input v-model="ruleLxrForm.goufbh" style="width:215px" :disabled="true"></el-input>
					</el-form-item>

					<el-form-item label="联系人编号:" prop="lianxrbh" :label-width="formLabelWidth">
						<el-input v-model="ruleLxrForm.lianxrbh" style="width:215px" :disabled="true"></el-input>
					</el-form-item>
				</div>
				<div class="demo-ruleForm-item">
					<el-form-item label="联系人:" prop="lianxr" :label-width="formLabelWidth">
						<el-input v-model="ruleLxrForm.lianxr" style="width:215px"
							:disabled="xztitle == '查看客户联系人信息' ? true : false"></el-input>
					</el-form-item>

					<el-form-item label="联系人邮箱:" prop="lianxryx" :label-width="formLabelWidth">
						<el-input v-model="ruleLxrForm.lianxryx" style="width:215px"
							:disabled="xztitle == '查看客户联系人信息' ? true : false"></el-input>
					</el-form-item>
				</div>

				<div class="demo-ruleForm-item">
					<el-form-item label="联系人手机号:" prop="lianxrsj" :label-width="formLabelWidth">
						<el-input v-model="ruleLxrForm.lianxrsj" style="width:215px"
							:disabled="title == '查看客户联系人信息' ? true : false"></el-input>
					</el-form-item>
					<el-form-item label="缺省联系人:" prop="queslxr" :label-width="formLabelWidth">
						<!--                        <el-select v-model="ruleLxrForm.queslxr" :disabled="title=='查看客户联系人信息'?true:false ">-->
						<!--                            编辑页面也需要查看缺省-->
						<el-select v-model="ruleLxrForm.queslxr">
							<el-option label="是" value="1"></el-option>
							<el-option label="否" value="0"></el-option>
						</el-select>
					</el-form-item>
				</div>

				<div class="demo-ruleForm-item">
					<el-form-item label="联系人地址:" prop="lianxrdz" :label-width="formLabelWidth">
						<el-input type="textarea" v-model="ruleLxrForm.lianxrdz" style="width:580px"
							:disabled="title == '查看客户联系人地址信息' ? true : false"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<div style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="submitLxrForm('ruleLxrForm')"
					v-if="title != '查看客户联系人信息'">保存</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="lianxirendiag = false">返回</div>
			</div>
			<!-- <div class="buttomanniu">
                <el-button type="primary" @click="submitLxrForm('ruleLxrForm')" v-if="title!='查看客户联系人信息'">保存</el-button>
                <el-button @click="lianxirendiag=false;">返回</el-button>
            </div> -->
		</el-dialog>
		<!-- 客户主数据 -->
		<!-- 一级编辑弹层 -->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" width="900px" :close-on-click-modal="false">
			<!-- <minhead :Stringtitle="title" :isdiag="true"></minhead> -->
			<div class="Centerhorizontally" style="margin-bottom: 25px;">
				<div v-for="(item, index) in jbheadlist" :key="index" @click="changeindex(index)" class="choosediv"
					v-if="(title == '新增客户信息') & (index > 0) ? false : true">
					<div :style="chooseheadindex == index ? '' : 'opacity: 0.34'">{{ item.title }}</div>
					<div :style="chooseheadindex == index ? 'background: #0080FF' : 'background: white'"
						class="lineall"></div>
				</div>
			</div>
			<div style="width: 100%;max-height: 400px; overflow-y: auto;" class="horizontally"
				v-show="chooseheadindex == 0">
				<el-form :model="ruleForm" :rules="title == '查看客户信息' ? '' : rules" ref="ruleForm" label-width="100px"
					class="demo-ruleForm">
					<div class="demo-ruleForm-item">
						<el-form-item label="客户编号:" prop="goufbh" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.goufbh" style="width:215px ;"
								:disabled="title == '查看客户' || title == '编辑客户' ? true : false"></el-input>
							<el-button v-if="title == '新增客户信息'" size="mini" plain native-type="button"
								style="width: 10px;margin-left: 5px;" color="red" @click="getCustomerNumberByCode()">
								<i class="el-icon-refresh" style="width: 10px;margin-left: -7px;"></i>
							</el-button>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="客户名称:" prop="goufmc" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.goufmc" style="width:215px ;"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="客户税号:" prop="nasrsbh" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.nasrsbh" style="width:215px ;"
								:disabled="title == '查看客户' ? true : false" @input="invalidruleForm1('nasrsbh')"
								maxlength="20"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="是否预制:" prop="shifzdyzfp" :label-width="formLabelWidth">
							<el-select v-model="ruleForm.shifzdyzfp" :disabled="title == '查看客户' ? true : false"
								style="width:215px ;">
								<el-option label="是" value="1"></el-option>
								<el-option label="否" value="0"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="银行:" prop="yinhzh" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.yinhzh" style="width:580px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="地址:" prop="youxdz" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.youxdz" style="width:580px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="是否有效:" prop="shifyx" :label-width="formLabelWidth">
							<el-select v-model="ruleForm.shifyx" placeholder="有效"
								:disabled="title == '查看客户' ? true : false" style="width:215px ;">
								<el-option label="有效" value="1"></el-option>
								<el-option label="停用" value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="参考字段1:" prop="cank1" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.cank1" style="width:215px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="参考字段2:" prop="cank2" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.cank2" style="width:215px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
						<el-form-item label="参考字段3:" prop="cank3" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.cank3" style="width:215px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
					<div class="demo-ruleForm-item">
						<el-form-item label="参考字段4:" prop="cank4" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.cank4" style="width:215px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
						<el-form-item label="参考字段5:" prop="cank5" :label-width="formLabelWidth">
							<el-input v-model="ruleForm.cank5" style="width:215px"
								:disabled="title == '查看客户' ? true : false"></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="width: 100%;" v-show="chooseheadindex == 1 && isOpenType != 0">
				<div class="arealxr">
					<div class="alledit" style="font-size:20px; padding:10px">
						<el-button size="small" type="primary" plain style="width: 100px;" color="red" v-if="title == '编辑客户主数据' ? true : false"
							@click="handleLxrAdd('', '', '新增客户联系人信息')" :disabled="title == '查看客户' ? true : false">
							新增
						</el-button>
					</div>
					<div class="alledit" style="font-size:20px; padding:10px">
						<el-input style="width:380px" placeholder="请输入联系人编号、联系人、联系人手机号、联系人邮箱"
							prefix-icon="el-icon-search" v-model="likeLxrSearch" clearable
							@input="forserchlxrgroup"></el-input>
					</div>
				</div>
				<div class="alledit-table">
					<el-table ref="multipleTable" border :data="tableLxrData" style="width: 100%" height="250"
						@selection-change="handleSelectionLxrChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column prop="goufbh" label="客户编号"></el-table-column>

						<el-table-column prop="lianxrbh" label="联系人编号"></el-table-column>
						<el-table-column prop="lianxr" label="联系人"></el-table-column>
						<el-table-column prop="lianxrdz" label="联系人地址"></el-table-column>

						<el-table-column prop="queslxr" label="是否缺省">
							<template slot-scope="scope">
								<p v-if="scope.row.queslxr == '0'">否</p>
								<p v-if="scope.row.queslxr == '1'">是</p>
							</template>
						</el-table-column>
						<el-table-column prop="lianxrsj" label="联系人手机"></el-table-column>
						<el-table-column prop="lianxryx" label="联系人邮箱"></el-table-column>
						<el-table-column label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="handleLxrDel(scope.$index, scope.row, '删除')" type="text" size="small"
									v-if="title == '编辑客户主数据' ? true : false">
									删除
								</el-button>
								<el-button type="text" size="small"
									@click="handleLxrEdit(scope.$index, scope.row, '编辑客户主数据')"
									v-if="title == '编辑客户主数据' ? true : false">
									编辑
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--                &lt;!&ndash; 分页 &ndash;&gt;-->
				<el-pagination @size-change="handleSizeChangetosee" @current-change="handleCurrentChangetosee"
					:page-sizes="[20, 30, 50, 100]" :page-size="pagenumLxr"
					layout="total, sizes, prev, pager, next, jumper" :total="totalLxr"></el-pagination>
			</div>
			<div style="justify-content: right; display: flex;margin-top: 30px;">
				<div class="addstyle" style="width: 80px;margin-left: 20px;" @click="submitForm('ruleForm')"
					v-if="title != '查看客户'">保存</div>
				<div class="backstyle" style="width: 80px;margin-left: 20px;" @click="returnForm()">返回</div>
			</div>
			<!-- <div class="buttomanniu">
				<el-button type="primary" @click="submitForm('ruleForm')" v-if="title != '查看客户'">保存</el-button>
				<el-button @click="returnForm()">返回</el-button>
			</div> -->
		</el-dialog>

		<!-- 头部 -->
		<!-- 	<div class="top">
            <div class="crumbs">
                <el-breadcrumb separator=">">
                    <el-breadcrumb-item>
                        <i class="el-icon-lx-cascades"></i>
                        主数据管理
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>
                        客户主数据
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div> -->
		<div class="area1" style="font-size:20px; padding:16px 16px 16px 0px">
			<div class="alledit">
				<!-- <el-button size="small" type="primary" plain style="width: 100px;" color="red"
                           @click="handleAdd('', '', '新增客户信息')">新增
                    <i class="el-icon-circle-plus-outline  el-icon--right"></i></el-button> -->
				<div  class="addstyle" style="width: 110px; margin-right: 10px;" @click="handleAdd('', '', '新增客户主数据')">
					<samp>
						新增
						<i class="el-icon-circle-plus-outline  el-icon--right"></i>
					</samp>
				</div>

				<!-- <el-button type="primary" plain style="width: 100px;" @click="forupload">
                    下载模板
                    <i class="el-icon-download  el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="forupload">
					<samp>
						下载模板
						<i class="el-icon-download  el-icon--right"></i>
					</samp>
				</div>
				<el-dropdown class="avatar-container" trigger="click" style="margin:0 10px">
					<!--  <div class="avatar-wrapper">
                        <el-button type="primary" plain>
                            导入 <i class="el-icon-bottom el-icon--right"></i>
                        </el-button>
                    </div> -->
					<div class="addstyle" style="width: 110px; margin-right: 10px;">
						<samp>
							导入
							<i class="el-icon-bottom el-icon--right"></i>
						</samp>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="handleImport('excl')">导入模板文件</el-dropdown-item>
						<el-dropdown-item @click.native="handleImport('ukeyXml')">导入xml文件</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<!--  <el-button type="primary" @click="excelExport" plain style="width: 100px;">
                    导出
                    <i class="el-icon-upload2 el-icon--right"></i>
                </el-button> -->
				<div class="addstyle" style="width: 110px; margin-right: 10px;" @click="excelExport">
					<samp>
						导出
						<i class="el-icon-upload2 el-icon--right"></i>
					</samp>
				</div>
				<!--   <el-button size="small" type="danger" plain style="width: 100px;" color="red"
                           @click="handleDel('', '', '删除客户信息')">删除
                    <i class="el-icon-delete  el-icon--right"></i></el-button> -->
				<div class="dangestyle" style="width: 110px; margin-right: 10px;" @click="handleDel('', '', '删除客户信息')">
					<samp>
						删除
						<i class="el-icon-delete  el-icon--right"></i>
					</samp>
				</div>
			</div>
			<div class="alledit" style="font-size:20px; padding:10px">
				<el-input style="width:440px" clearable placeholder="请输入客户编号、客户名称、纳税人识别号、银行账号、地址、电话"
					prefix-icon="el-icon-search" v-model="likeSearch" @input="forserchgroup"></el-input>
			</div>
		</div>
		<div class="alledit-table">
			<div class="tableh">
				<el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark"
					height="calc(100vh - 250px )" @selection-change="handleSelectionChange" @row-click="selectClick">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column prop="goufbh" label="客户编号" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>

					<el-table-column prop="goufmc" label="客户名称" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="shifyx" label="是否有效" align="center" min-width="100">
						<template slot-scope="scope">
							<p v-if="scope.row.shifyx == '1'">有效</p>
							<p v-if="scope.row.shifyx == '0'">停用</p>
						</template>
					</el-table-column>

					<el-table-column prop="nasrsbh" label="客户纳税人识别号" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="yinhzh" label="银行账号" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="youxdz" label="地址、电话" align="left" min-width="160px"
						show-overflow-tooltip></el-table-column>

					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<el-button @click="handleEdit(scope.$index, scope.row, '查看客户主数据')" type="text"
								size="small">预览</el-button>
							<el-button type="text" size="small"
								@click="handleEdit(scope.$index, scope.row, '编辑客户主数据')">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!--         分页 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:page-sizes="[20, 30, 50, 100]" :key="elementui_page_component_key" :current-page="currentpage"
			:page-size="pagenum" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
	<!--    </div>-->
</template>

<script>
	import axios from 'axios';

	export default {
		created() {
			//  this.useropj=JSON.parse(localStorage.getItem('useropj'))
			// this.getGroupCompanyList(this.useropj.groupId)
			this.getCustomerList();
		},
		mounted() {
			this.$nextTick(() => {
				this.tableHeight = this.diagheight();
				this.$refs.multipleTable.doLayout();
				window.onresize = () => {
					this.tableHeight = this.diagheight();
					this.$refs.multipleTable.doLayout();
				};
			});
		},
		methods: {
		
			handleSelectionChange(e) {
				(this.ids = ''),
				e.forEach((item, index) => {
					this.ids = this.ids + item.id + ',';
				});
				var reg = /,$/gi;
				this.ids = this.ids.replace(reg, '');
			},
			selectClick(row, column, event) {
				this.$refs.multipleTable.toggleRowSelection(row);
			},
			handleSelectionLxrChange(e) {
				(this.ids = ''),
				e.forEach((item, index) => {
					this.ids = this.ids + item.id + ',';
				});
				var reg = /,$/gi;
				this.ids = this.ids.replace(reg, '');
			},
			changeindex(index) {
				this.chooseheadindex = index;
				if (index == '1') {
					this.getCustomerLxrList(this.kehugoufbh);
				}
			},
			/* 获取公司列表 */
			getGroupCompanyList(id) {
				let params = id;
				this.$https.fetchPost('sys/getGroupCompanyList', params).then(res => {
					this.AllCompanylist = res.data.obj;
					if (this.AllCompanylist) {
						this.nowcolom = this.AllCompanylist[0].id;
						this.changecolom();
					}
				});
			},
			handleDel() {
				if (this.ids == '') {
					this.$message({
						type: 'error',
						message: '请选择要删除的客户主数据'
					});
					return false;
				}
				this.delCustomer();
			},
			handleLxrDel(index,row,str) {
				this.ids = row.id;
				if (this.ids == '') {
					this.$message({
						type: 'error',
						message: '请选择要删除的客户主联系人数据'
					});
					return false;
				}
				this.delCustomerLxr();
				this.ids = "";
			},
			forupload() {
				this.downloadCustomerDefaultTemplate();
			},
			/* 接口调用操作 */
			downloadCustomerDefaultTemplate() {
				location.href = this.$https.baseURL + 'master/downloadCustomerDefaultTemplate';
			},
			handleImport(type) {
				this.release();
				this.fileType = type;
				this.daorudiag = true;
			},
			excelExport() {
				let url = this.$https.baseURL + 'master/getCustomerExcel'; //请求下载文件的地址
				// let token=localStorage.getItem('token')
				let param = {
					serchval: '',
					headTitle: '',
					headFiled: '',
					headLxrTitle: '',
					headLxrFiled: '',
					ids: ''
				};
				param.serchval = this.likeSearch;
				param.headTitle = this.checkmeauList;
				param.headFiled = this.checkHeadFiled.toString();
				param.headLxrTitle = this.checkmeauLxrList;
				param.headLxrFiled = this.checkHeadLxrFiled.toString();
				param.ids = this.ids;
				this.$https.fetchdowload(url, param).then(res => {
					const content = res.data;
					const blob = new Blob([content]);
					var date = new Date().getFullYear() + '' + (new Date().getMonth() + 1) + '' + new Date()
						.getDate();
					var companyName = JSON.parse(localStorage.getItem('useropj')).currCompany.name;
					const fileName = companyName + date + '客户主数据' + '.xls';
					if ('download' in document.createElement('a')) {
						// 非IE下载
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href); // 释放URL 对象
						document.body.removeChild(elink);
					} else {
						// IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
				});
				// if(token != "" & token !=null){
				// 	axios.defaults.headers.common['token']=token
				// }
				// axios.post(url,param,{responseType:"blob"})
				// 			.then(res => {
				// 				 let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
				// 				 let objectUrl = URL.createObjectURL(blob);
				// 				 window.location.href = objectUrl;

				// 			})
				// 			.catch(error => {
				// 				this.$message.error(error);
				// 			});
			},

			release() {
				this.upfilename = '';
				this.filestate = null;
				this.upfile = '';
				this.radionochoose = '';
			},
			uploadFile($event) {
				this.upfilename = $event.target.files[0].name;
				var reader = new FileReader();
				let fileData = $event.target.files[0];
				let formData = new FormData();
				formData.append('uploadFile', fileData);
				formData.append('type', this.fileType);
				this.upfile = formData;
			},
			sureupload() {
				this.uploadExcel(this.upfile);
			},
			/* 上传标准模板 */
			uploadExcel(upfile) {
				var url;
				if (this.fileType === 'excl') {
					url = 'master/uploadCustomerExcel';
				} else if (this.fileType === 'ukeyXml') {
					url = 'master/uploadCustomerUkeyXml';
				}
				let params = upfile;
				this.$https.fetchPost(url, params).then(res => {
					if (res.data.success) {
						this.getCustomerList();
						this.daorudiag = false;
					}
				});
			},
			/* 新增客户主数据 */
			handleAdd(index, row, title) {
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				this.title = title;
				Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
				this.isOpenType = '0';
				this.ruleForm = {
					shifyx: '1',
					shifzdyzfp: '1'
				};
				this.jbheadlist = [{
					title: '主信息'
				}]
				this.chooseheadindex = '0'
				this.dialogFormVisible = true;
			},
			handleEdit(index, row, title) {
				this.title = title;
				this.isOpenType = '1';
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
				console.log('查看的数据', row);
				this.dialogFormVisible = true;
				this.kehugoufbh = row.goufbh;
				this.ruleForm = JSON.parse(JSON.stringify(row));
				this.jbheadlist = [{
						title: '主信息'
					},
					{
						title: '联系人信息'
					}
				];
				this.chooseheadindex = '0'
				this.getCustomerLxrList(this.kehugoufbh);
			},
			handleLxrAdd(index, row, title) {
				this.$nextTick(() => {
					this.$refs['ruleLxrForm'].clearValidate();
				});
				console.log(index);
				this.xztitle = title;
				Object.keys(this.ruleLxrForm).map(key => (this.ruleLxrForm[key] = ''));
				this.ruleLxrForm = {
					queslxr: '0',
					goufbh: this.ruleForm.goufbh
				};
				this.lianxirendiag = true;
			},
			handleLxrEdit(index, row, title) {
				this.title = title;
				this.$nextTick(() => {
					this.$refs['ruleLxrForm'].clearValidate();
				});
				console.log('查看的数据', row);
				this.lianxirendiag = true;
				this.ruleLxrForm = JSON.parse(JSON.stringify(row));
			},
			submitForm(formName) {
				console.log(this.$refs[formName]);
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.updateCustomer();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			submitLxrForm(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						this.updateCustomerLxr();
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			returnForm() {
				this.dialogFormVisible = false;
				Object.keys(this.ruleForm).map(key => (this.ruleForm[key] = ''));
			},
			handleSizeChange(val) {
				this.pagenum = val;
				this.getCustomerList();
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getCustomerList();
			},

			handleSizeChangetosee(val) {
				this.pagenumLxr = val;
				this.getCustomerLxrList(this.kehugoufbh);
			},
			handleCurrentChangetosee(val) {
				this.pageLxr = val;
				this.getCustomerLxrList(this.kehugoufbh);
			},
			/* 所有客户主数据列表数据搜索 */
			forserchgroup() {
				this.currentpage = 1;
				this.elementui_page_component_key++;
				this.page = 1;
				this.getCustomerList();
			},
			/* 所有客户主数据列表数据搜索 */
			forserchlxrgroup() {
				this.getCustomerLxrList(this.kehugoufbh);
			},
			/* 接口数据 */
			/* 设为不可见 */
			delCustomer() {
				let params = {
					ids: this.ids
				};
				this.$https.fetchPost('/master/deleteCustomerList', params).then(res => {
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4004]);
						this.getCustomerList();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			delCustomerLxr() {
				let params = {
					ids: this.ids
				};
				this.$https.fetchPost('/master/deleteCustomerLxrList', params).then(res => {
					if (res.data.success) {
						// this.$message.success(this.$tolertJSON[4004]);
						this.$message.success('删除成功');
						this.getCustomerLxrList(this.kehugoufbh);
					} else {
						this.$message.error(res.data.message);
					}
				});
			},

			/* 	编辑客户主数据 */
			updateCustomer() {
				var url = '';
				var type = '';
				if (this.ruleForm.id == '' || this.ruleForm.id == null) {
					url = '/master/addCustomer';
					type = '0';
				} else {
					url = '/master/updateCustomer';
					type = '1';
				}
				let params = {
					customerData: JSON.stringify(this.ruleForm)
				};
				this.$https.fetchPost(url, params).then(res => {
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4020]);
						// if(type=='0'){
						this.dialogFormVisible = false;
						// }
						this.kehugoufbh = this.ruleForm.goufbh;
						this.getCustomerList();
					} else {
						// this.$message.error(res.data.message)
					}
				});
			},
			/* 	编辑客户联系人主数据 */
			updateCustomerLxr() {
				var url = '';
				if (this.ruleLxrForm.id == '' || this.ruleLxrForm.id == null) {
					url = '/master/addCustomerLxr';
				} else {
					url = '/master/updateCustomerLxr';
				}
				let params = {
					customerLxrData: JSON.stringify(this.ruleLxrForm)
				};
				this.$https.fetchPost(url, params).then(res => {
					if (res.data.success) {
						this.$message.success(this.$tolertJSON[4020]);
						this.lianxirendiag = false;
						this.getCustomerLxrList(this.kehugoufbh);
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			/*  获取客户主数据列表数据*/
			getCustomerList() {
				let params = {
					// search: {qiybh:"91500115MA1K3R189Qsy01"},
					likeSearch: this.likeSearch,
					page: this.page,
					pagenum: this.pagenum,
					limit: this.pagenum,
					sort: 'asc',
					order: 'id'
				};
				this.$https.fetchPost('/master/getCustomerList', params).then(res => {
					console.log(res);
					this.tableData = res.data.data;
					this.total = res.data.count;
					this.tableData.forEach(item => {
						item.shifyx = item.shifyx == 1 ? '1' : '0';
					});
				});
			},
			/*  获取客户主联系人数据列表数据*/
			getCustomerLxrList(kehugoufbh) {
				let params = {
					likeSearch: this.likeLxrSearch,
					page: this.pageLxr,
					pagenum: this.pagenumLxr,
					limit: this.limit,
					sort: 'asc',
					order: 'id',
					search: {
						goufbh: kehugoufbh
					}
				};
				this.$https.fetchPost('/master/getCustomerLxrList', params).then(res => {
					console.log(res);
					this.tableLxrData = res.data.data;
					this.totalLxr = res.data.count;
				});
			},
			invalidruleForm1(type) {
				switch (type) {
					case 'nasrsbh':
						this.ruleForm1.nasrsbh = this.ruleForm1.nasrsbh.replace(/[^\da-zA-Z]/g, '');
						break;
				}
			},
			getCustomerNumberByCode() {
				this.$https.fetchPost('/master/getCustomerNumberByCode').then(res => {
					if (res.data.success) {
						var fromData = JSON.parse(JSON.stringify(this.ruleForm));
						fromData.goufbh = res.data.obj;
						this.ruleForm = fromData;
					}
				});
			}
		},
		data() {
			var validateLianxrsjInfo = (rule, value, callback) => {
				//var reg = /^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/;
				var reg = /^1[3-9]\d{9}$/;
				console.log(value);
				if (value != "" && value != undefined) {
					if (!reg.test(value)) {
						callback(new Error('只能输入手机格式'));
					} else {
						callback();
					}
				} else {
					callback(new Error('手机格式错误'));
				}
			};

			var validateLianxryxInfo = (rule, value, callback) => {
				// var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
				var reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
				console.log(value);
				if (value != "" && value != undefined) {
					if (!reg.test(value)) {
						callback(new Error('只能输入邮箱格式'));
					} else {
						callback();
					}
				} else {
					callback();
				}

			};
			var validateGoufInfo = (rule, value, callback) => {
				var reg = /^[\u4e00-\u9fa5A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入汉字和英文字母'));
				} else {
					callback();
				}
			};
			var validateBianmInfo = (rule, value, callback) => {
				var reg = /^[A-z0-9]+$/gi; //
				if (!reg.test(value)) {
					callback(new Error('只能输入字母和数字'));
				} else {
					callback();
				}
			};
			var validateNasrsbhInfo = (rule, value, callback) => {
				if (value != '' && value != undefined) {
					var reg = /^[A-Z0-9]+$/g; //
					if (!reg.test(value)) {
						callback(new Error('只能输入大写字母和数字'));
					} else {
						// if (value.length == '15' || value.length == '18' || value.length == '20') {
						//     callback();
						// } else {
						//     callback(new Error('只能输入15,18,20长度的字母和数字'));
						// }
						var regt = /[IOZSV]/g;
						if (regt.test(value)) callback(new Error('税号中不能包含I、O、Z、S、V'));
						if (value.length == '18') {
							callback();
						} else {
							callback(new Error('只能输入18位长度的字母和数字'));
						}
					}
				}
			};

			return {
				xztitle: '',
				checkmeauList: [
					'客户编码',
					'客户名称',
					'客户税号',
					'银行',
					'地址',
					'手机号',
					'是否自动预制发票',
					'是否有效',
					'参考信息一',
					'参考信息二',
					'参考信息三',
					'参考信息四',
					'参考信息五'
				],
				checkHeadFiled: ['goufbh', 'goufmc', 'nasrsbh', 'yinhzh', 'youxdz', 'shoujhm', 'shifzdyzfp', 'shifyx',
					'cank1', 'cank2', 'cank3', 'cank4', 'cank5'
				],

				checkmeauLxrList: ['客户编号', '联系人编号', '联系人', '是否缺省', '联系人地址', '联系人手机', '联系人邮件'],
				checkHeadLxrFiled: ['goufbh', 'lianxrbh', 'lianxr', 'queslxr', 'lianxrdz', 'lianxrsj', 'lianxryx'],

				daorudiag: false,
				daorutitle: ['选择文件'],
				upfilename: '',
				filestate: '',
				currentpage: 1,
				elementui_page_component_key: '',
				upfile: '',
				khtitle: ['主数据管理'],
				seeids: '', //可见用户选中id
				ids: '', //非可见用户选中id
				AllCompanylist: '',
				nowcolom: '',
				isshow: true,
				// 编辑弹层
				dialogFormVisible: false,
				title: '编辑客户',
				lianxirendiag: false,
				tableHeight: '',
				ruleForm: {
					goufbh: '',
					goufmc: '',
					nasrsbh: '',
					youxdz: '',
					shifzdyzfp: '',
					shifyx: ''
				},
				ruleLxrForm: {},
				chooseheadindex: 0,
				jbheadlist: [{
						title: '主信息'
					},
					{
						title: '联系人信息'
					}
				],

				rules: {
					goufbh: [
						//     {
						//     required: true,
						//     message: '请输入客户编号',
						//     trigger: 'blur'
						// },
						// {
						//     validator: validateBianmInfo,
						//     trigger: 'blur'
						// },
						{
							max: 50,
							message: '长度在 50个字符',
							trigger: 'blur'
						}
					],

					goufmc: [{
							required: true,
							message: '请输入客户名称',
							trigger: 'blur'
						},
						{
							max: 100,
							message: '长度在 100个字符',
							trigger: 'blur'
						}
					],

					/*nasrsbh: [{
                        required: false,
                        message: '请输入客户名称',
                        trigger: 'blur'
                    },
                        {
                            validator: validateNasrsbhInfo,
                            trigger: 'blur'
                        }
                    ],

                    yinhzh: [/!*{
                        required: true,
                        message: '请输入银行',
                        trigger: 'blur'
                    },*!/
                        {
                            max: 100,
                            message: '长度在 100个字符',
                            trigger: 'blur'
                        }
                    ],*/
					youxdz: [
						/*{
                        required: true,
                        message: '请输入地址',
                        trigger: 'blur'
                    },*/
						{
							max: 100,
							message: '长度在 100个字符',
							trigger: 'blur'
						}
					],
					shifyx: [{
						required: true,
						message: '请选择是否有效',
						trigger: 'blur'
					}],
					shifzdyzfp: [{
						required: true,
						message: '请选择是否预制',
						trigger: 'blur'
					}]
				},
				rulelxrs: {
					goufbh: [{
						required: true
					}],
					lianxr: [{
							required: true,
							message: '请选择联系人',
							trigger: 'blur'
						},
						{
							max: 50,
							message: '长度在 50个字符',
							trigger: 'blur'
						}
					],
					lianxryx: [{
							max: 100,
							message: '长度在 100个字符',
							trigger: 'blur'
						},
						{
							validator: validateLianxryxInfo,
							trigger: 'blur'
						}
					],
					lianxrsj: [{
						required: true,
						message: '请填写手机号',
						validator: validateLianxrsjInfo,
						trigger: 'blur'
					}],
					lianxrdz: [{
							required: true,
							message: '请选择联系人地址',
							trigger: 'blur'
						},
						{
							max: 80,
							message: '长度在 80个字符',
							trigger: 'blur'
						}
					],
					queslxr: [{
						required: true,
						message: '请选择缺省联系人',
						trigger: 'blur'
					}]
				},
				formLabelWidth: '150px',
				search: {
					taxIdentificationNumber: '', //客户编号
					customerName: '', //客户名称
					isEffective: '', //是否有效
					taxIdentificationNumber: '', //纳税人识别号
					customercustomerTaxpayerType: '', ///客户纳税人类型
					customerInvoiceType: '', //客户发票类型
					customerName: '' //客户名称
				},

				//搜索
				likeSearch: '',
				likeLxrSearch: '',
				likeSearchtosee: '',
				tableData: [], //表格数据
				tableLxrData: [], //表格数据
				total: '', //总条数
				totalLxr: '', //总条数
				page: 1, //第几页
				pageLxr: 1,
				pagenum: 20, //每页条数
				pagenumLxr: 20, //每页条数
				limit: 10,
				kehugoufbh: '',
				isOpenType: '',
				fileType: 'excl'
			};
		}
	};
</script>

<style scoped="scoped" lang="less">
	/deep/ .el-table--small td {
		padding: 4px 0;
	}

	.plain {
		/* background-color: #b3d8ff; */
		background-color: #409eff;
		opacity: 0.7;
	}

	.sendinput {
		visibility: hidden;
	}

	.bt1 {
		width: 80px;
		height: 31px;
		border: 1px solid #e5e5e5;
		border-radius: 3px;
		font-size: 14px;
		cursor: pointer;
		font-weight: 500;
		color: #2f66fc;
	}

	.blue {
		background-color: #409eff;
	}

	/* 编辑弹层 */
	.demo-ruleForm-item {
		display: flex;
	}

	.top {
		width: 100%;
		border-bottom: 1px solid #ccc;
		padding: 10px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.area1:extend(.between-line) {
		border-bottom: 1px solid #ccc;
		margin-right: 20px;
		margin-right: 20px;
		box-sizing: border-box;
	}

	.arealxr:extend(.between-line) {
		border-bottom: 1px solid #ccc;
		margin-right: 10px;
		margin-right: 10px;
		box-sizing: border-box;
	}

	.alledit {
		display: flex;
		justify-content: space-between;
	}

	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}

	.move-btn {
		text-align: center;
		margin-top: 20px;
	}

	.el-icon-d-arrow-left,
	.el-icon-d-arrow-right {
		transform: rotate(-90deg);
	}

	.export-img {
		width: 10px;
		height: 10px;
		margin-right: 3px;
		vertical-align: baseline;
	}

	.lineall {
		width: 39px;
		height: 3px;
		border-radius: 2px;
		margin-top: 11px;
	}

	.choosediv:extend(.Verticalcenter-line) {
		font-size: 20px;
		color: #0080ff;
		margin-right: 48.5px;
		cursor: pointer;
		margin-left: 48.5px;
	}
</style>